import { TFunction } from 'i18next'

import { AccountProcessor, Country } from '../../../../../utils/types'

export const unionPayNames = ['FastPay p2p', 'Zotapay-CUP p2p', 'AloPay', 'RPN p2p', 'Nova2pay', 'Nova2Pay p2p', 'Transact365 p2c']
export const processorsWithNotice = [...unionPayNames, 'MPSA', 'OTC365']

export const checkForUnionPay = (processor?: AccountProcessor) => {
  return processorsWithNotice.includes(processor?.name || '')
}

export const checkForCCprocessor = (processor?: AccountProcessor) => {
  return ['Credit Card', 'Credit Card (SC)'].includes(processor?.name || '')
}

export const getProcessorName = (option: AccountProcessor, t: TFunction) =>
  t(`processors:${option.displayName || option.name}:title`, option.displayName)

const DEFAULT_SORT_NUMBER = 100

const CHN_SORT: Record<string, number> = {
  "MyPay": 2,
  "OTC365": 1,
  "Zotapay-CUP p2p": 3,
}

export const getQuickDepositOptions = (currency?: string): number[] | undefined => {
  const options: Record<string, number[]> = {
    AUD: [100, 500, 1000],
    BRL: [500, 2500, 5000],
    CAD: [100, 500, 1000],
    CHF: [100, 500, 1000],
    CNY: [100, 500, 1000],
    EUR: [100, 500, 1000],
    GBP: [100, 500, 1000],
    GHS: [1000, 5000, 10000],
    HKD: [800, 4000, 8000],
    IDR: [2000000, 10000000, 16000000],
    JPY: [5000, 20000, 50000, 100000],
    KES: [10000, 50000, 100000],
    MXN: [2000, 10000, 20000],
    MYR: [500, 2000, 4000],
    NGN: [150000, 800000, 1500000],
    NZD: [100, 500, 1000],
    PKR: [30000, 150000, 300000],
    SGD: [150, 700, 1500],
    THB: [3500, 15000, 30000],
    USD: [100, 500, 1000],
    VND: [2500000, 10000000, 20000000],
    ZAR: [1500, 10000, 20000],
    CNH: [700, 3500, 7000],
    PHP: [5500, 30000, 55000]
  }
  return currency ? options[currency] : undefined
}

export const getRoundingFraction = (amount: number) => {
  let fraction = 1
  if (amount > 1E6) {
    fraction = 10000
  } else if (amount > 100000) {
    fraction = 1000
  } else if (amount > 10000) {
    fraction = 100
  } else if (amount > 1000) {
    fraction = 10
  }
  return fraction
}

export const sortProcessors = (processors: AccountProcessor[], userCountry?: Country) => {
  if (userCountry?.code3 === 'CHN') {
    return [...processors].sort((a, b) =>
      (CHN_SORT[a.name] || DEFAULT_SORT_NUMBER) - (CHN_SORT[b.name] || DEFAULT_SORT_NUMBER))
  }
  return [...processors]
}

export const submitPostForm = (method: string, url: string, params: any, acceptCharset?: string, target?: string) => {
  var form = document.createElement("form")
  form.action = url
  form.method = method
  form.target = target || "_self"
  form.acceptCharset = acceptCharset || "UTF-8"
  if (params) {
    for (var key in params) {
      var input = document.createElement("textarea")
      input.name = key
      input.value = typeof params[key] === "object"
        ? JSON.stringify(params[key])
        : params[key]
      form.appendChild(input)
    }
  }
  form.style.display = 'none'
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

export const ibwProcessor: AccountProcessor = {
  id: -111,
  autoWithdrawalAllowed: false,
  bank: false,
  behavingLikeBankWire: false,
  conversionFee: 0,
  creditCard: false,
  deposit24Limit: 0,
  displayName: 'International Bank Transfer',
  isClientDepositAllowed: false,
  isClientWithdrawalAllowed: false,
  name: 'International Bank Transfer',
  processorFee: 0,
  refundAllowed: false,
  type: "Bank",
  used: true,
}

export const cryptoProcessor: AccountProcessor = {
  id: -222,
  autoWithdrawalAllowed: false,
  bank: false,
  behavingLikeBankWire: false,
  conversionFee: 0,
  creditCard: false,
  deposit24Limit: 0,
  displayName: 'Crypto',
  isClientDepositAllowed: true,
  isClientWithdrawalAllowed: true,
  name: 'Crypto',
  processorFee: 0,
  refundAllowed: false,
  type: "e-Wallet",
  used: true,
}

export const googlePayProcessor: AccountProcessor = {
  id: -444,
  autoWithdrawalAllowed: true,
  bank: false,
  behavingLikeBankWire: false,
  conversionFee: 0,
  creditCard: false,
  deposit24Limit: 1000,
  displayName: "Google Pay",
  isClientDepositAllowed: true,
  isClientWithdrawalAllowed: true,
  limit: undefined,
  name: "Google Pay",
  processorFee: 1,
  refundAllowed: false,
  type: "CC",
  used: true,
}

export const applePayProcessor: AccountProcessor = {
  id: -555,
  autoWithdrawalAllowed: true,
  bank: false,
  behavingLikeBankWire: false,
  conversionFee: 0,
  creditCard: false,
  deposit24Limit: 1000,
  displayName: "Apple Pay",
  isClientDepositAllowed: true,
  isClientWithdrawalAllowed: true,
  limit: undefined,
  name: "Apple Pay",
  processorFee: 1,
  refundAllowed: false,
  type: "CC",
  used: true,
}
